module.exports = __webpack_public_path__ + "static/media/logo.f8a98177.png";